/** Represents a keycode. */
export enum BarKeyCode {
    Backspace = 8,
    Enter = 13,
    End = 35,
    Home = 36,
    LeftArrow = 37,
    UpArrow = 38,
    RightArrow = 39,
    DownArrow = 40,
    Delete = 46
}
